module.exports = __webpack_public_path__ + "img/Card_Center.c9fe9c4b.gif";